module.exports = __webpack_public_path__ + "img/mgh-nihonbashi-premier@2x.36b7f784.jpg";